import { helper } from '@ember/component/helper';
import { formatDistanceToNowStrict, isDate } from 'date-fns';

export function relativeDate([date, addSuffix = true]) {
  return isDate(date) ? formatDistanceToNowStrict(date, { addSuffix }) : '/';
}

export default helper(relativeDate);
